import { useState, useEffect } from "react";

// Evaluate a quantity expression for assembly components.
// Accepts a plain number ("0.2") OR a simple fraction/ratio ("1/5" = one every 5 ft).
// Returns a Number, or "" when blank/invalid.
export function parseQtyExpr(input) {
  if (input === null || input === undefined) return "";
  const s = String(input).trim();
  if (s === "") return "";
  const frac = s.match(/^(-?\d*\.?\d+)\s*\/\s*(-?\d*\.?\d+)$/);
  if (frac) {
    const d = parseFloat(frac[2]);
    return d ? parseFloat(frac[1]) / d : "";
  }
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : "";
}

const trimNum = (n) => {
  if (n === "" || n === null || n === undefined) return "";
  const r = Math.round(Number(n) * 1e6) / 1e6;
  return Number.isFinite(r) ? String(r) : "";
};

// Fraction-aware quantity field. Drop-in for a plain number input: same className.
// Type "1/5" (or any a/b) and it stores the evaluated decimal (0.2) on blur / Enter.
export function QtyInput({ value, onChange, className = "", testid, title = "Type a number, or a fraction like 1/5 (one every 5)", placeholder }) {
  const [raw, setRaw] = useState(trimNum(value));
  const [focused, setFocused] = useState(false);
  useEffect(() => { if (!focused) setRaw(trimNum(value)); }, [value, focused]);
  const commit = (txt) => { const n = parseQtyExpr(txt); onChange(n); setRaw(trimNum(n)); };
  return (
    <input
      type="text"
      inputMode="text"
      value={raw}
      onFocus={() => setFocused(true)}
      onChange={(e) => setRaw(e.target.value)}
      onBlur={(e) => { setFocused(false); commit(e.target.value); }}
      onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
      className={className}
      data-testid={testid}
      title={title}
      placeholder={placeholder}
    />
  );
}
